import React, {useState, useEffect, createContext} from 'react';

export const Context = createContext();
export const {Provider, Consumer} = Context;

